// extracted by mini-css-extract-plugin
export default {"featuresItem":"aZT73","imgWrapper":"OKP83","videoContainer":"xjv5r","image":"HB3ja","iconPlay":"YkwNK","name":"Q0tm9","description":"rg08q","video":"NVD8L"};